// Native shim — controller is web-only (service worker scope).
// Return empty default so consumers' destructures don't crash.
export default function useExtensionUpdateControllerState(): any {
  return {} as any
}
